import * as yup from 'yup';

export const budgetValidationSchema = yup.object({
  customBidAmount: yup
    .number()
    .when(['$minBidAmount'], {
      is: (minBidAmount: number) => minBidAmount > 0 && minBidAmount !== undefined,
      then: yup.number().min(yup.ref('$minBidAmount'), 'campaigns.ads.bid.minimum-bid-amount'),
    })
    .test('max-bid-amount', 'campaigns.ads.bid.maximum-bid-amount', (value: number, context) => {
      const { parent, resolve } = context;
      const maxBidAmount: number = resolve(yup.ref('$maxBidAmount'));
      const { budgetAmount } = parent;
      if (value > maxBidAmount) {
        return context.createError({ message: 'campaigns.ads.bid.maximum-bid-amount' });
      }
      if (value > budgetAmount) {
        return context.createError({ message: 'campaigns.ads.bid.maximum-custom-bid-amount' });
      }
      return true; // Validation passed
    }),
  budgetAmount: yup
    .number()
    .when(['$minWeeklyBudget'], {
      is: (minWeeklyBudget: number) => minWeeklyBudget > 0 && minWeeklyBudget !== undefined,
      then: yup.number().min(yup.ref('$minWeeklyBudget'), 'campaigns.ads.budget.minimum-budget'),
    })
    .when(['$maxWeeklyBudget'], {
      is: (maxWeeklyBudget: number) => maxWeeklyBudget > 0 && maxWeeklyBudget !== undefined,
      then: yup.number().max(yup.ref('$maxWeeklyBudget'), 'campaigns.ads.budget.maximum-budget'),
    }),
  bidStrategy: yup.mixed().oneOf(['auto', 'custom']).required(),
});
